import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Rebuild from './components/Rebuild/Rebuild';
import * as Styles from './ProductTemplatesPage.styles';
import useLocale from '@/hooks/useLocale';
import { useHistory } from 'react-router';
import ProductTemplateAbout from './components/ProductTemplateAbout/ProductTemplateAbout';
import CurrentSOInfo from './components/CurrentSOInfo/CurrentSOInfo';
import AvailableOptions from './components/AvailableOptions/AvailableOptions';
import VpsStoreLoaderPage from '../components/VpsStoreLoaderPage/VpsStoreLoaderPage';
import VpsStoreModal from '@/pages/Products/VpsOciDetailPage/ProductTemplatesPage/commons/VpsStoreModal';
import { locale } from '@/utils/locale';
import { vpsOciActions } from '@/redux/modules/productDetail/vpsOci';

const ProductTemplatesPage = ({
  setShowProductTemplatesPage,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id: hostingId } = useParams();
  const [modalType, setModalType] = useState('confirmRebuild');

  const vpsOci = useSelector(state => state.vpsOci);

  const { invoiceGenerated, invoiceId: imageInvoiceId } = useSelector(state => state.vpsOci?.changeImage?.data);

  const rebuildStatus = useSelector(state => state.vpsOci?.rebuild?.status);
  const changeImageStatus = useSelector(state => state.vpsOci?.changeImage?.status);

  const statusQueue = rebuildStatus || changeImageStatus;
  const statusQueueIsSuccess = statusQueue === 'success';

  const statusData = useSelector(state => state.vpsOci?.status?.value);
  const statusVpsOciIsOnline = statusData === 'online';

  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: vpsOciLocale } = productDetailsLocale;

  const handleCloseModal = () => {
    setModalType(null);
  };

  useEffect(() => {
    if (invoiceGenerated) {
      history.push(`${locale('routes.billing')}${locale('routes.unpaid')}/${imageInvoiceId}?openInvoice=true`);
      return;
    }

    if (statusQueue === 'success') {
      const intervalId = setInterval(() => {
        if (hostingId) {
          dispatch(vpsOciActions.data.get({ hostingId }));
        }
      }, 20000);

      return () => clearInterval(intervalId);
    } if (statusQueue === 'server_inactive') {
      setModalType('serverInactive');
    } else if (statusQueue === 'limit_exceeded') {
      setModalType('limitExceeded');
    } else if (statusQueue === 'not_found') {
      setModalType('notFound');
    } else if (statusQueue === 'unknown_error') {
      setModalType('unknownError');
    } else if (statusQueue === 'unknown_error_change_image') {
      setModalType('unknownErrorChangeImage');
    }
  }, [statusQueue, dispatch, hostingId, history, imageInvoiceId, invoiceGenerated]);

  useEffect(() => {
    if (statusQueueIsSuccess && statusVpsOciIsOnline) {
      window.location.href = `${locale('routes.products')}${locale('routes.productdetail')}/${hostingId}`;
    }
  }, [statusQueueIsSuccess, statusVpsOciIsOnline, hostingId]);

  if (
    !vpsOci
    || !vpsOci.data
    || Object.keys(vpsOci).length === 0
    || Object.keys(vpsOci.data).length === 0
  ) return null;

  if (statusQueueIsSuccess) {
    return (
      <VpsStoreLoaderPage
        title={vpsOciLocale.store.rebuild.feedback.request.title}
        description={vpsOciLocale.store.rebuild.feedback.request.description}
        isLoaderBuilder
      />
    );
  }

  return (
    <Styles.Container data-testid="vpsoci-templates-page">
      <ProductTemplateAbout
        setShowProductTemplatesPage={setShowProductTemplatesPage}
      />

      <CurrentSOInfo />

      <AvailableOptions />

      <Rebuild />

      <VpsStoreModal
        modalType={modalType}
        onClose={handleCloseModal}
      />
    </Styles.Container>
  );
};

export default ProductTemplatesPage;
